import { render, staticRenderFns } from "./calc-loader.vue?vue&type=template&id=750dfa42&scoped=true"
import script from "./calc-loader.vue?vue&type=script&lang=js"
export * from "./calc-loader.vue?vue&type=script&lang=js"
import style0 from "./calc-loader.vue?vue&type=style&index=0&id=750dfa42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750dfa42",
  null
  
)

export default component.exports